// src/api/categories.ts

import api from '@/lib/axios';
import type { ProductCategory } from '@/types/category';

/**
 * 获取产品类别树
 * GET /v1/developer/categories?level={level}
 * @param level - 最大层级（默认 2）
 */
export const getCategories = (level: number = 2): Promise<ProductCategory[]> => {
  return api.get(`/developer/categories?level=${level}`);
};

/**
 * 获取单个类别详情
 * GET /v1/developer/categories/{category_id}
 * @param categoryId - 类别 ID
 */
export const getCategory = (categoryId: string): Promise<ProductCategory> => {
  return api.get(`/developer/categories/${categoryId}`);
};